export const LOW_CONFIDENCE_STATUS = 'published_low_confidence';
export const OSINT_EVENT_NOTE = 'This event is based on open-source intelligence (OSINT). An evidence confidence level is attached to the event.';

export function isPublishedRiskEvent(event: any): boolean {
    return event?.vettingStatus === undefined || event.vettingStatus === LOW_CONFIDENCE_STATUS
        || (event.vettingStatus === 'approved' && event.verified === true);
}
